import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Privacy() {
    return (
        <div className="bg-ink-900 text-cream min-h-screen px-6 py-16">
            <div className="container-prose max-w-2xl mx-auto" data-testid="privacy-page">
                <Link
                    to="/"
                    className="inline-flex items-center gap-2 text-sm text-cream-muted hover:text-clay mb-10 transition"
                    data-testid="privacy-back-link"
                >
                    <ArrowLeft size={14} /> Back to the guide
                </Link>

                <p className="label-eyebrow mb-3">Restful Press</p>
                <h1 className="heading-display text-4xl md:text-5xl mb-8">Privacy Policy</h1>
                <p className="text-sm text-cream-muted/70 mb-12">Last updated: February 2026</p>

                <div className="prose-content space-y-6 text-cream-muted leading-relaxed">
                    <p>
                        This is a small, independent publishing project. We collect as little
                        information as possible, and we do not sell or rent any of it.
                    </p>

                    <h2 className="font-serif text-2xl text-cream mt-10 mb-2">What we collect</h2>
                    <p>
                        When you buy <em>The 7-Day Sleep Reset</em>, we collect your email address
                        and a payment reference from Paystack. We never see your card number.
                        Anonymous browsing data (page views, referrer) may be collected via
                        PostHog to help us understand which parts of the page are useful.
                    </p>

                    <h2 className="font-serif text-2xl text-cream mt-10 mb-2">How we use it</h2>
                    <ul className="list-disc pl-6 space-y-2">
                        <li>To deliver your guide and any add-ons you purchase.</li>
                        <li>To send a receipt and, occasionally, an update if we improve the guide.</li>
                        <li>To respond to your emails when you write to us.</li>
                    </ul>

                    <h2 className="font-serif text-2xl text-cream mt-10 mb-2">Who we share with</h2>
                    <p>
                        We share the minimum needed with the services that make this work:
                        Paystack for payments and PostHog for anonymous analytics. We do not
                        share your email with anyone else.
                    </p>

                    <h2 className="font-serif text-2xl text-cream mt-10 mb-2">Your control</h2>
                    <p>
                        You can ask us to delete your record at any time. Just email{" "}
                        <a href="mailto:hello@restfulpress.com" className="text-clay hover:underline">
                            hello@restfulpress.com
                        </a>{" "}
                        and we will remove your data within seven days.
                    </p>

                    <h2 className="font-serif text-2xl text-cream mt-10 mb-2">Cookies</h2>
                    <p>
                        We use a small number of cookies — for analytics and to remember your
                        cart while you check out. There are no advertising trackers.
                    </p>

                    <h2 className="font-serif text-2xl text-cream mt-10 mb-2">Contact</h2>
                    <p>
                        Questions about this policy? Write to{" "}
                        <a href="mailto:hello@restfulpress.com" className="text-clay hover:underline">
                            hello@restfulpress.com
                        </a>
                        .
                    </p>
                </div>
            </div>
        </div>
    );
}
